import { Injectable } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { AlertControlFacade } from '../../internal';

@Injectable()
export class ClipboardAuthorFacade {
  constructor(private alertControlFacade: AlertControlFacade) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Lazy Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">

  async requestCopyToClipboard(text: string | number | null | undefined) {
    if (!text) return;
    await navigator.clipboard.writeText(text?.toString() ?? '');
    this.alertControlFacade.requestAddAlert({
      key: 'main',
      detail: 'notification.copied_to_clipboard',
      severity: FlatModels.AlertControlModels.AlertType.enum.success,
      life: FlatModels.AlertControlModels.AlertTime.DEFAULT
    });
  }

  //</editor-fold>

}
